<template>
  <div class="menus">
    <v-row align="center" style="margin: 0 !important">
      <v-col
        align="center"
        v-for="item in aboutusItems"
        :key="item.name"
        cols="4"
        sm="3"
        lg="2"
        class="menuCol"
      >
        <v-btn class="btn-menus" @click="goToRoute(item.route)">
          <div>
            <font-awesome-icon
              :icon="item.icon"
              class="menuIcon"
              size="2x"
              :color="item.color"
            />
          </div>
          <span class="menuTitle" :style="[{ color: '#5c5c5c' }]">{{
            item.title
          }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aboutusItems: [
        {
          icon: "book-open",
          title: "رشته ها",
          name: "MAJORS",
          route: "/aboutus/majors",
          needActive: true,
          color: "#345678",
        },
        {
          icon: "list",
          title: "آیین نامه ها",
          name: "AYINNAMEHS",
          route: "/aboutus/ayinnamehs",
          needActive: true,
          color: "#0E814C",
        },
        {
          icon: "school",
          title: "مدارس",
          name: "SCHOOLS",
          route: "/aboutus/schools",
          needActive: true,
          color: "#722435",
        },
      ],
    };
  },
  methods: {
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
  },
};
</script>

<style>
.menus {
  width: 100%;
  min-height: calc(100vh - 80px);
  position: absolute;
}
</style>
